const ParishProfileTab = {
    general: "general",
    pictures: "pictures",
    files: "files"
};

export default ParishProfileTab;
